/**
 * Version only the affected collection when its persisted shape changes. Epoch 1 preserves
 * existing cache IDs; a new ID gets both fresh rows and fresh Electric resume metadata.
 * Old epochs remain on disk until an explicit full cache reset, allowing old tabs to finish.
 */
const collectionCacheEpochs: Record<string, number> = {
  'tanstack-issues': 1,
  'tanstack-issue-types': 1,
  'tanstack-vehicles': 1,
  'tanstack-users': 1,
  'tanstack-guests': 1,
  'tanstack-issue-attributes': 2,
  'tanstack-datafleet-issues': 1,
}

export function persistedCollectionId(id: string, epoch = collectionCacheEpochs[id]): string {
  if (epoch === undefined) throw new Error(`Missing cache epoch for persisted collection: ${id}`)
  return epoch === 1 ? id : `${id}:cache-${epoch}`
}
